export const ChampionsLeagueStages = {
  FirstQualifying: "1st Qualifying Round",
  SecondQualifying: "2nd Qualifying Round",
  ThirdQualifying: "3rd Qualifying Round",
  Playoff: "Play-off Round",
  LeaguePhase: "League Phase",
  KnockoutPlayoffs: "Knockout Round Play-offs",
  RoundOf16: "Round of 16",
  QuarterFinal: "Quarter-final",
  SemiFinal: "Semi-final",
  Final: "Final",
};

export const LEAGUE_NAME_KEYWORDS = Object.freeze({
  CHAMPIONS_LEAGUE: "champions league",
  AFCON: "africa cup of nations",
  WORLD_CUP: "world cup",
});

export const DATE_TIME_FORMAT = "MMM d, yyyy H:mm";

export const MATCH_EVENTS_PER_PAGE = 15;

export const MatchType = Object.freeze({
  TEAMS: "teams",
  COUNTRIES: "countries",
});

export const MatchStatus = Object.freeze({
  UPCOMING: "upcoming",
  LIVE: "live",
  FINISHED: "finished",
});
